const condo_sec3Object = payload => {
  return {
    type: "condosec3",
    payload
  };
};

export default condo_sec3Object;
